/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewRunColorListDTO
 */
export interface NewRunColorListDTO {
    /**
     * Unique, case-sensitive name of the list in the project
     * @type {string}
     * @memberof NewRunColorListDTO
     */
    name: string;
}

/**
 * Check if a given object implements the NewRunColorListDTO interface.
 */
export function instanceOfNewRunColorListDTO(value: object): value is NewRunColorListDTO {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function NewRunColorListDTOFromJSON(json: any): NewRunColorListDTO {
    return NewRunColorListDTOFromJSONTyped(json, false);
}

export function NewRunColorListDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewRunColorListDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function NewRunColorListDTOToJSON(value?: NewRunColorListDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
    };
}

